module.exports = __webpack_public_path__ + "img/features-3-relations.2cabf1fd.png";